module.exports = __webpack_public_path__ + "img/user-document.17329356.svg";